import { of as observableOf, Observable} from 'rxjs';
import { map } from "rxjs/operators";
import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";

export class ImageWithDescriptionModel {
  Id: number = 0;
  ObjectId: number = 0;
  Name: string = "";
  Image: string;

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.ObjectId = data["objectId"];
      this.Name = data["name"];
    }
  }

  static fromJS(data: any): ImageWithDescriptionModel {
    data = typeof data === 'object' ? data : {};
    let result = new ImageWithDescriptionModel();
    result.init(data);
    return result;
  }
}

@Injectable()
export class ObjectPhotosService
{

  constructor(private client: HttpClient)
  {
  }

  public get(objectId: number): Observable<ImageWithDescriptionModel[]>
  {
    return this.client.get<any>("/ctrl/objects/photos/" + objectId).pipe(map(values =>
    {
      let result = [];
      if (values && values.constructor === Array)
        for (let item of values)
          result.push(ImageWithDescriptionModel.fromJS(item));
      return result;
    }));
  }

  public delete(id: number) {
    return this.client.delete("/ctrl/objects/photos/" + id);
  }

  public update(obj: ImageWithDescriptionModel) {
    return this.client.put("/ctrl/objects/photos/", obj);
  }
}
